export default "__VITE_ASSET__DnKLazYb__"